import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { NgForm, FormControl } from '@angular/forms';
import { MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineLatest, Subject, Subscription, Observable, } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { NotificationService } from 'src/app/shared/notification.service';

@Component({
  selector: 'common-popup',
  templateUrl: './common-popup.html',
  styleUrls: ['./common-popup.css']
})
export class CommonPopup implements OnDestroy {
  filteredOptions
  filter$ = new Subject()
  selectedProduct = null;
  autComObj
  lookupLoading = false;
  submitting = false;
  submitError: string = null;
  constructor(
    private notifierService: NotificationService,
    public dialogRef: MatDialogRef<CommonPopup>,
    @Inject(MAT_DIALOG_DATA) public data,
    ) {
    //console.log("common pop data", this.data)

    // if(this.haveProductPicker()){
    //   //console.log(this.data.formData.inputFeilds.filter(input => input.type === 'product-select')[0].value)
    //   this.selectedProduct = this.data.formData.inputFeilds.filter(input => input.type === 'product-select')[0].value;
    // }

    if(data.formData.autoCom){
      this.filteredOptions = combineLatest(
        this.data.formData.autoCom, this.filter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
          // console.log(data)
          return (data as Array<{}>).filter(option=> option['name'].toLowerCase().includes(filter))
        }))
        // this.data.formData.autoCom.subscribe((data)=>{
        //   console.log("Common Popup",data)
        // })
    }
    
  }

  // haveProductPicker(){
  //   return this.data.formData.inputFeilds.filter(input => input.type === 'product-select').length > 0;
  // }

  applyFilter(filterValue: string) {
    this.filter$.next(filterValue.toLowerCase());
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(form){

    if(typeof form === 'object'){
      // Submit was pressed
      // if(this.haveProductPicker()){
      //   form.value.product = this.selectedProduct;
      // }

      // Opt-in async validation: if the caller supplied onSubmit, run it and
      // only close the dialog on success. On failure the form (and whatever
      // the operator typed) stays put instead of being thrown away and the
      // error is shown inline, e.g. a password that fails Firebase Auth's
      // policy.
      if (this.data.formData.onSubmit) {
        this.submitError = null;
        this.submitting = true;
        Promise.resolve(this.data.formData.onSubmit(form.value))
          .then(result => {
            this.submitting = false;
            if (result && result.success === false) {
              this.submitError = result.message || 'Something went wrong';
              return;
            }
            this.dialogRef.close(form);
          })
          .catch(err => {
            this.submitting = false;
            this.submitError = err?.message || 'Something went wrong';
          });
        return;
      }
    }
    this.dialogRef.close(form);
  }

  ngOnDestroy(){
    // console.log("Popup Destoryed");
  }

  onProductSelected(product){
    this.selectedProduct = product;
  }

  // Optional per-field lookup (e.g. org. number -> company info autofill).
  // A field opts in via `inputFeilds[].lookup = { buttonLabel, handler, targets }`.
  runLookup(inputValue, form: NgForm) {
    if (!inputValue.lookup?.handler || this.lookupLoading) return;
    const control = form.controls[inputValue.name];
    const value = control ? control.value : inputValue.value;
    if (!value) return;

    this.lookupLoading = true;
    Promise.resolve(inputValue.lookup.handler(value))
      .then(result => {
        if (!result) return;
        Object.keys(result).forEach(key => {
          const target = this.data.formData.inputFeilds.find(f => f.name === key);
          if (target) target.value = result[key];
          const ctrl = form.controls[key];
          if (ctrl) ctrl.setValue(result[key]);
        });
      })
      .catch(err => this.notifierService.showNotification('error', err?.message || 'Lookup failed'))
      .finally(() => this.lookupLoading = false);
  }

}
